import {RiDeleteBin5Line} from "react-icons/ri";
import {SlArrowDown, SlArrowRight, SlArrowUp} from "react-icons/sl";
import React from "react";
import mapping from "../../../config/mapping";
import FilterSubItem from "../FilterSubItem/FilterSubItem";


const FilterItem = ({

                        item,
                        clearFilters = () => {
                        },
                        selectedOptions,
                        isExpanded,
                        toggleSubCategoryExpansion,
                        toggleCategoryExpansion,
                        expandedSubCategories,
                        handleFilterOptionChange,
                        handleRadioFilterOptionChange,
                        toggleCategorySelection,
                        isCheckboxVisible,
                        isFromListing,
                        lang
                    }) => {
    return (

        <div aria-labelledby={item?.title}>
            <div className="category-title">
                <span>
                    {item?.title}
                    {(selectedOptions[item.categoryId]?.length > 0 && isFromListing===false) && (
                        <RiDeleteBin5Line
                            className="clear-filter-button"
                            onClick={() => clearFilters(item.categoryId)}
                            style={{marginLeft: '10px'}}
                            size={20}
                        />
                    )}
                </span>
            </div>
            <ul className="filter-items-list"
                style={{
                    maxHeight: (isExpanded) ? 'none' : '200px',
                    width: '100%',
                    overflowY: 'auto',
                    scrollbarWidth: 'none'
                }}>
                {
                    item?.items.slice(0, (!isExpanded) ? 4 : item?.items.length).map((subItem, subIndex) => {
                        const subItemsLength = item?.items?.length;
                        return (
                            <li key={subIndex} className="filter-item" tabIndex={0}>
                                <label className="filter-item-label">
                                    {mapping.filterContent(
                                        item?.title,
                                        subItem,
                                        item,
                                        subItemsLength,
                                        selectedOptions,
                                        handleFilterOptionChange,
                                        handleRadioFilterOptionChange,
                                        toggleSubCategoryExpansion,
                                        expandedSubCategories,
                                        toggleCategorySelection,
                                        isCheckboxVisible,
                                        isFromListing,
                                        lang
                                    )}
                                    <span className={"count"}>({subItem.aggregate})</span>
                                </label>

                                {subItem?.items && subItem?.items.length > 0 && expandedSubCategories && expandedSubCategories[subItem?.title] && (
                                    <FilterSubItem
                                        subItems={subItem?.items}
                                        category={item?.title}
                                        expandedSubCategories={expandedSubCategories}
                                        toggleSubCategoryExpansion={toggleSubCategoryExpansion}
                                        toggleCategorySelection={toggleCategorySelection}
                                        selectedOptions={selectedOptions}
                                        item={item}
                                        subItem={subItem}
                                        isFromListing = {isFromListing}
                                    />
                                )}
                            </li>
                        );
                    })
                }
            </ul>
            <div className="c ">
                <div className="filter-category" style={{paddingBottom: '20px'}}>
                    {item?.items.length > 4 && (
                        <button className="expand-button" onClick={() => toggleCategoryExpansion(item?.title)}>
                            {lang === "en"? (isExpanded ? "Less" : "More"):( isExpanded ? "Λιγότερα" : "Περισσότερα")}
                        </button>
                    )}
                </div>
            </div>
        </div>

    );
};

export default FilterItem;